/**
 * 富文本编辑器初始化模块
 * 配置 vue-html5-editor，支持中文界面、图片上传（阿里云 OSS）
 */
import Vue from 'vue'
import VueHtml5Editor from 'vue-html5-editor'

export default function () {
  let opt = {
    /** 全局组件名称 */
    name: "vue-html5-editor",
    /** 是否显示模块名称（工具栏图标旁显示文字） */
    showModuleName: true,
    /** 自定义图标 class（使用 Font Awesome 图标） */
    icons: {
      text: "fa fa-pencil",
      color: "fa fa-paint-brush",
      font: "fa fa-font",
      align: "fa fa-align-justify",
      list: "fa fa-list",
      link: "fa fa-chain",
      unlink: "fa fa-chain-broken",
      tabulation: "fa fa-table",
      image: "fa fa-file-image-o",
      hr: "fa fa-minus",
      eraser: "fa fa-eraser",
      undo: "fa-undo fa",
      "full-screen": "fa fa-arrows-alt",
      info: "fa fa-info",
    },
    /** 图片模块配置 */
    image: {
      /** 文件最大体积：5MB */
      sizeLimit: 512 * 1024 * 10,
      /** 上传配置：上传到阿里云 OSS */
      upload: {
        url: 'https://cloudexhibition.chinafastenerinfo.com/api/admin/uploadfile/news/',
        headers: { "Authorization": "JWT " + localStorage.getItem('adminToken') },
        params: {},
        fieldName: 'file'
      },
      /** 图片压缩配置：最大 600x600，质量 80% */
      compress: {
        width: 600,
        height: 600,
        quality: 80
      },
      /** 上传响应处理：返回阿里云 OSS 图片链接 */
      uploadHandler(responseText) {
        var json = JSON.parse(responseText);
        var url = 'https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/news/' + json.filename
        return url
      }
    },
    /** 界面语言：简体中文 */
    language: "zh-cn",
    /** 中文语言包 */
    i18n: {
      "zh-cn": {
        "align": "对齐方式",
        "image": "图片",
        "list": "列表",
        "link": "链接",
        "unlink": "去除链接",
        "table": "表格",
        "font": "文字",
        "full screen": "全屏",
        "text": "排版",
        "eraser": "格式清除",
        "info": "关于",
        "color": "颜色",
        "please enter a url": "请输入地址",
        "create link": "创建链接",
        "bold": "加粗",
        "italic": "倾斜",
        "underline": "下划线",
        "strike through": "删除线",
        "subscript": "上标",
        "superscript": "下标",
        "heading": "标题",
        "font name": "字体",
        "font size": "文字大小",
        "left justify": "左对齐",
        "center justify": "居中",
        "right justify": "右对齐",
        "ordered list": "有序列表",
        "unordered list": "无序列表",
        "fore color": "前景色",
        "background color": "背景色",
        "row count": "行数",
        "column count": "列数",
        "save": "确定",
        "upload": "上传",
        "progress": "进度",
        "unknown": "未知",
        "please wait": "请稍等",
        "error": "错误",
        "abort": "中断",
        "reset": "重置"
      }
    },
    /** 隐藏的模块（无） */
    hiddenModules: [],
    /** 显示的模块及其顺序 */
    visibleModules: [
      "text",
      "color",
      "font",
      "align",
      "list",
      "link",
      "unlink",
      "tabulation",
      "image",
      "hr",
      "eraser",
      "undo",
      "full-screen",
    ],
    /** 扩展模块（无） */
    modules: {}
  };
  Vue.use(VueHtml5Editor, opt);
}



// WEBPACK FOOTER //
// ./src/utils/initHTMLEditor.js